import { motion } from "motion/react";
import { Heart, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router";
import Analytics from "../../../utils/analytics";

interface WelcomeScreenProps {
  onNavigate: (nextScreen: string) => void;
}

export function Welcome({ onNavigate }: WelcomeScreenProps) {

  return (
    <div className="pt-6 pb-6 flex items-center justify-center p-4 background-sand">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl w-full text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="inline-flex items-center justify-center mb-4"
        >
          <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden">
                <img 
                  src="/assets/images/balanceTest/balance-asbjorn-250x250px.png" 
                  alt="Balance illustration" 
                  className="w-full h-full object-cover"
                />
              </div>
          {/* <Heart className="w-10 h-10" style={{ color: "var(--warm-accent)" }} /> */}
        </motion.div>

        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mb-4 text-4xl"
        >
          Work-Life Balance
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-lg mb-8 leading-relaxed opacity-80"
        >
          Hvordan går det egentlig med din balance? Brug et øjeblik på at reflektere over din arbejdssituation. Det tager kun et par minutter.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="space-y-4"
        >
          <div className="bg-white rounded-2xl p-6 shadow-sm">
            <div className="flex items-start gap-4 text-left">
              <div className="w-8 h-8 rounded-full bg-[var(--warm-sand)] flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-sm">6</span>
              </div>
              <div>
                <p className="mb-2">
                  <strong>6 spørgsmål</strong> om dit arbejde
                </p>
                <p className="text-sm opacity-70">
                  Vær ærlig – det er kun for dig selv
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm mb-4">
            <div className="flex items-start gap-4 text-left">
              <div className="w-8 h-8 rounded-full bg-[var(--warm-sand)] flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-sm">5</span>
              </div>
              <div>
                <p className="mb-2">
                  <strong>5 gode råd</strong> tilpasset dig
                </p>
                <p className="text-sm opacity-70">
                  Baseret på dine svar får du personlige anbefalinger
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => {
            //console.log("int", "start quiz");
            Analytics.getInstance().trackBalanceTest("start", "start");
            onNavigate("quiz");
          }}
          className="button mt-8 px-8 py-4 rounded-full  text-white shadow-lg hover:shadow-xl transition-shadow inline-flex items-center gap-2 cursor-pointer"
        >
          Start testen
          <ArrowRight className="w-5 h-5" />
        </motion.button>
      </motion.div>
    </div>
  );
}